export enum Route {
  USER_SIGNATURE = '/:id',
  USER_CONSUMPTION_PRODUCTS = '/consumption-products',
  SUCCESS = '/success',
  CHECKOUT ='/checkout'
}
